import { lmsClient } from "api";

const buildGlJournalSchemeParams = (data = {}) => {
  const params = new URLSearchParams();
  params.append("pageIndex", data.pageIndex ?? 0);
  params.append("pageSize", data.pageSize ?? 10);
  params.append("queryBuilderId", data.queryBuilderId || "");
  return params.toString();
};

const GlJournalSchemeService = {};

GlJournalSchemeService.getGlJournalSchemeList = function (data = {}) {
  return lmsClient({
    url: `/lms/GlJournalScheme/search?${buildGlJournalSchemeParams(data)}`,
    method: "get",
  });
};

export default GlJournalSchemeService;
